import React, { useState } from 'react';
import {
  Box,
  Typography,
  Paper,
  Button
} from '@mui/material';
import {
  FileCopy as FileCopyIcon
} from '@mui/icons-material';
import TradeTemplates from '../components/templates/TradeTemplates';
import { useNavigate } from 'react-router-dom';

const TemplatesPage = () => {
  const navigate = useNavigate();
  const [selectedTemplate, setSelectedTemplate] = useState(null);

  const handleApplyTemplate = (template) => {
    // Store the selected template in localStorage to be used in the trade form
    localStorage.setItem('selectedTemplate', JSON.stringify(template));
    navigate('/add-trade');
  };

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom sx={{ mb: 3, display: 'flex', alignItems: 'center', gap: 1 }}>
        <FileCopyIcon /> Trade Templates
      </Typography>
      
      <Typography variant="body1" color="text.secondary" paragraph>
        Create and manage templates to speed up your trade entry process. Templates allow you to pre-fill common trade setups, strategies, and parameters.
      </Typography>
      
      <TradeTemplates onApplyTemplate={handleApplyTemplate} />
    </Box>
  );
};

export default TemplatesPage;